import { Injectable } from '@angular/core';
import { Api } from '../api/api';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';

/*
  Generated class for the ReqListeProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ReqListeProvider {

  constructor(private api: Api) {
    console.log('Hello ReqListeProvider Provider');
  }

    getListe(page,json){
  	return this.api.post(page,json)
  	.do(this.logResponse)
  	.map(this.extractData)
  }

  private logResponse(res){
	//console.log(res)
  }

  private extractData(res){
	return res;
  }

}



// WEBPACK FOOTER //
// ./src/providers/req-liste/req-liste.ts